// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__khJ3K","label":"Category_label__1NVdC","content":"Category_content__fP9et","header":"Category_header__1ENxQ","location":"Category_location__3L1Bh"};